exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".network-status{position:fixed;z-index:1001;text-align:center;display:flex;justify-content:center;color:#fff;width:100%;padding:3px 0;letter-spacing:0.7px}.network-status.online{background:#4caf50}.network-status.offline{background:#ea5858}\n", ""]);

